import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatWidget(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.15 16.55c.216.3.55.45 1 .45.216 0 .42-.067.613-.2a.998.998 0 0 0 .387-.475L9.2 13.4h5.65l1 2.925a.996.996 0 0 0 .388.475c.19.133.387.2.587.2.466 0 .808-.15 1.024-.45.217-.3.242-.667.075-1.1l-4.25-11.3c-.116-.317-.337-.588-.662-.813-.325-.225-.654-.337-.988-.337-.35 0-.691.112-1.024.337-.334.225-.559.496-.675.813l-4.25 11.3c-.167.433-.142.8.075 1.1Zm7.95-5.15H9.9l2.05-5.8h.1l2.05 5.8Z"
      />
      <path fill="currentColor" d="M6 20h12a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2Z" />
    </BaseIcon>
  );
}
